import { toast } from 'react-hot-toast';
import { useCallback } from 'react';

// 提供与之前假设的 useToasts 接口兼容的简单封装
export const useToasts = () => {
  // 使用 useCallback 保证引用稳定，避免依赖它的 useEffect 频繁重新执行
  const addToast = useCallback((message, type = 'default') => {
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'loading':
        toast.loading(message);
        break;
      default:
        toast(message);
    }
  }, []);
  return { addToast };
};
